import { render } from "./BovineSearch.vue?vue&type=template&id=23fdf615&scoped=true"
import script from "./BovineSearch.vue?vue&type=script&lang=js"
export * from "./BovineSearch.vue?vue&type=script&lang=js"

import "./BovineSearch.vue?vue&type=style&index=0&id=23fdf615&lang=scss&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fdf615"]])

export default __exports__